// import enLocale from 'element-ui/lib/locale/lang/en'
const English = {
	common: {
		home: 'Home'
	}
}

export default English
